module.exports = __webpack_public_path__ + "img/python.05d8e48a.png";